import React, { useState } from 'react';
import { Container, Header, Title, Text, Button, Icon, Footer, Left, Body, Right, ListItem, Content, Separator } from 'native-base';
import { Platform, Linking, WebView, StyleSheet } from 'react-native';

export default function SaNoSubmission({ year, navigation }) {
	return (
		<Container>
			<Header>
				<Left>
					<Button transparent onPress={() => navigation.goBack()}>
						<Icon active name="ios-arrow-back" />
					</Button>
				</Left>
				<Body>
					<Title>Self-Assessment</Title>
					<Text style={styles.headerTxt}>{year.text}</Text>
				</Body>
				<Right />
			</Header>
			<Content>
				<Text>You cannot submit this year, sorry</Text>
			</Content>
		</Container>
	);
}

const styles = StyleSheet.create({
	headerTxt: {
		color: '#EEE'
	},
	rightText: {
		textAlign: 'right',
		fontSize: 14
	},
	rightTextSmall: {
		textAlign: 'right',
		fontSize: 11
	},
	white: { color: '#FFF' }
});
